var exports = {
  "content": "x234b8571--3df863--content",
  "item": "x234b8571--3df863--item",
  "success": "x234b8571--3df863--success",
  "failure": "x234b8571--3df863--failure",
  "warning": "x234b8571--3df863--warning",
};

module.exports = exports;
